import React from 'react';
import StyleGuidePageContent from './StyleGuidePageContent.js';

export default class S extends React.Component {

    static PASSWORD = 'litt hemmelig';

    constructor(props) {
        super(props);
        this.state = {
            password: window.localStorage.getItem("styleguide.password")
        };

    }

    render() {
        if (this.isAuthenticated()) {
            return <StyleGuidePageContent/>
        } else {
            return <div className="content" style={{ marginBottom: '10px' }}>
                <form>
                    <input type="password" placeholder="Logg in for å se stilguide" onChange={event => this.handleChange(event)} />
                </form>
            </div>
        }
    }

    handleChange(event) {
        window.localStorage.setItem("styleguide.password", event.target.value);
        this.setState({
            password: event.target.value
        });
    }

    isAuthenticated() {
        return this.state.password === S.PASSWORD;
    }
}



// WEBPACK FOOTER //
// ./src/StyleGuidePage/index.js